import models from '@app/store/models';
import {
  addMenuTopAreaItem,
  AppContainer,
  createRoutes,
  NotFound,
  notification,
  PrivateRoute,
  RouteInfo,
  storage,
  Workspace,
} from '@digital/ui';

import { useActions } from '@digital/ui/lib/store';
import AuthProvider from './providers/AuthProvider';
import { initMsal, msalInstance } from './config/msalConfig';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Logo from '../public/images/logo_mrn_verde.svg';
import app from './config/app.json';
import menu from './config/menu.json';
import { getExpirationTime, getJwt, getLoggedUsername } from './helpers';
import {
  AbaRateio,
  AprovacaoDeItens,
  Aprovador,
  Area,
  BidCycle,
  BoletimMedicao,
  CaixaEntrada,
  Clausula,
  Configuracao,
  ContabilidadeGeral,
  Contrato,
  ContratoCompleto,
  ContratoSimples,
  ControleQaqc,
  DashboardContratos,
  DashboardMedicoes,
  DefinicaoDeComprador,
  DemandasEmAndamento,
  Departamento,
  DirecionarRevisoes,
  Diretoria,
  FormFornecedor,
  Login,
  LogSendMail,
  Matching,
  Minutas,
  Municipio,
  OrdemCompra,
  PainelFinanceiro,
  Perfil,
  PerfilAcesso,
  Perguntas,
  PreSuprimentosAcervo,
  PreSuprimentosAcervoDemandante,
  PreSuprimentosDemandas,
  PreSuprimentosSuprimentos,
  PreSuprimentosTemplates,
  PrimeiroAcesso,
  Proposta,
  RecuperarSenha,
  Changelog,
  RelatorioControleQaQc,
  RelatorioDashboard,
  RelatorioEncerramentoContratos,
  RelatorioOrdemCompra,
  RelatorioOrdemDeCompra,
  RelatorioPreContratacao,
  RelatorioPrevisoesPagto,
  RelatorioSegurosGarantias,
  RelatorioStatusCorrespondencias,
  RelatorioStatusMedicoes,
  RequisitanteCapex,
  ValidacaoCapex,
  SumarioExecutivo,
  TabelaPerguntas,
  TipoServico,
  Usuario,
  UsuarioSubstituto,
  ClassificacaoServico,
  RelatorioClassificacaoGastos,
  LoginPortal,
  LogoutPortal,
  ManuaisEProcedimentos,
  Controladoria,
  OrdemCompraPropostaTecnicaDownload,
  RelatorioMonitoramentoSubcontratacoes,
  RelatorioSubContratacao,
  AuthRedirect,
} from './views';
import { GetSas } from './api/configuracoes';
import { RecoilRoot, useSetRecoilState } from 'recoil';
import { parametrosSasState, usuarioLogadoState } from './atoms';
import { getUsuarioLogadoInfo } from './api/usuario';


const routes: RouteInfo[] = [
  { path: '/contratos', component: Contrato, permissions: ['CONTRATO_GERAL_VISUALIZAR_MENU'] },
  { path: '/diretorias', component: Diretoria, permissions: ['DIRETORIA_VISUALIZAR_MENU'] },
  { path: '/usuarios', component: Usuario, permissions: ['USUARIO_VISUALIZAR_MENU'] },
  { path: '/perfilAcesso', component: PerfilAcesso, permissions: ['USUARIO_VISUALIZAR_MENU'] },
  { path: '/municipios', component: Municipio },
  { path: '/tiposservicos', component: TipoServico, permissions: ['TIPO_SERVICO_VISUALIZAR_MENU'] },
  { path: '/areas', component: Area, permissions: ['AREA_VISUALIZAR_MENU'] },
  { path: '/departamentos', component: Departamento },
  { path: '/boletimDeMedicoes', component: BoletimMedicao, permissions: ['MEDICAO_QUANTITATIVA_VISUALIZAR_MENU'] },
  { path: '/caixaDeEntrada', component: CaixaEntrada, permissions: ['CAIXA_DE_ENTRADA_VISUALIZAR_MENU'] },
  { path: '/meusDados', component: Perfil, permissions: ['USUARIO_MEUS_DADOS'] },
  { path: '/dashboardDeMedicoes', component: DashboardMedicoes, permissions: ['DASHBOARD_MEDICAO_VISUALIZAR_MENU'] },
  { path: '/dashboardDeContratos', component: DashboardContratos, permissions: ['DASHBOARD_CONTRATO_VISUALIZAR_MENU'] },
  { path: '/contratoSimples', component: ContratoSimples, permissions: ['RELATORIO_CONTRATO_SIMPLES_MENU'] },
  { path: '/contratoCompleto', component: ContratoCompleto, permissions: ['RELATORIO_CONTRATO_AVANCADO_MENU'] },
  { path: '/rateio', component: AbaRateio },
  { path: '/logSendMail', component: LogSendMail, permissions: ['MANUTENCAO_LOG_EMAIL'] },
  { path: '/matching', component: Matching, permissions: ['MATCHING_VISUALIZAR_MENU'] },
  {
    path: '/usuarioSubstituto',
    component: UsuarioSubstituto,
    permissions: ['MANUTENCAO_USUARIO_SUBSTITUTO_VISUALIZAR'],
  },
  { path: '/aprovador', component: Aprovador },
  {
    path: '/relatorioDePrevisoesDePagamento',
    component: RelatorioPrevisoesPagto,
    permissions: ['RELATORIO_PREVISOES_PAGAMENTO_VISUALIZAR_MENU'],
  },
  {
    path: '/relatorioDeStatusDeMedicoes',
    component: RelatorioStatusMedicoes,
    permissions: ['RELATORIO_MEDICOES_VISUALIZAR_MENU'],
  },
  {
    path: '/relatorioDeEncerramentoDeContratos',
    component: RelatorioEncerramentoContratos,
    permissions: ['RELATORIO_ENCERRAMENTO_VISUALIZAR_MENU'],
  },
  {
    path: '/relatorioDeSegurosEGarantias',
    component: RelatorioSegurosGarantias,
    permissions: ['RELATORIO_SEGUROS_GARANTIAS_VISUALIZAR_MENU'],
  },
  {
    path: '/relatorioDeStatusDeCorrespondencias',
    component: RelatorioStatusCorrespondencias,
    permissions: ['RELATORIO_CORRESPONDENCIA_VISUALIZAR_MENU'],
  },
  {
    path: '/relatorioPreContratacao',
    component: RelatorioPreContratacao,
    permissions: ['RELATORIO_PRE_CONTRATACAO_MENU'],
  },
  { path: '/primeiroAcesso', component: PrimeiroAcesso, permissions: ['dfc2fd92-3024-4641-9219-ea357a4eeeb3'] },
  { path: '/contabilidadeGeral', component: ContabilidadeGeral, permissions: ['CONTABILIDADE_GERAL_VISUALIZAR_MENU'] },
  {
    path: '/relatorioControleQaQc',
    component: RelatorioControleQaQc,
    permissions: ['RELATORIO_CONTROLE_QA_QC_VISUALIZAR_MENU'],
  },
  {
    path: '/relatorioOrdemDeCompra',
    component: RelatorioOrdemDeCompra,
    permissions: ['RELATORIO_ORDEM_DE_COMPRA'],
  },
  {
    path: '/parametros',
    component: Configuracao,
    permissions: ['CONFIGURACAO_MENU_VISUALIZAR'],
  },
  {
    path: '/controleQaqc',
    component: ControleQaqc,
    permissions: ['MEDICAO_CONTROLE_QAQC_VISUALIZAR'],
  },
  {
    path: '/templates',
    component: PreSuprimentosTemplates,
    permissions: ['PRE_SUPRIMENTOS_TEMPLATES_VISUALIZAR_MENU'],
  },
  {
    path: '/demandas',
    component: DemandasEmAndamento,
  },
  {
    path: '/suprimentos',
    component: PreSuprimentosSuprimentos,
    permissions: ['PRE_SUPRIMENTOS_SUPRIMENTOS_VISUALIZAR_MENU'],
  },
  {
    path: '/acervo',
    component: PreSuprimentosAcervo,
    permissions: ['PRE_SUPRIMENTOS_ACERVO_VISUALIZAR_MENU'],
  },
  {
    path: '/acervoDemandante',
    component: PreSuprimentosAcervoDemandante,
  },
  {
    path: '/ordenarPerguntas',
    component: TabelaPerguntas,
  },
  { path: '/perguntas', component: Perguntas, permissions: ['MINUTA_PERGUNTA'] },
  { path: '/clausula', component: Clausula, permissions: ['MINUTA_CLAUSULAS'] },
  {
    path: '/aprovacaoDeItens',
    component: AprovacaoDeItens,
    permissions: ['APROVADOR_CLAUSULA_NIVEL_1', 'APROVADOR_CLAUSULA_NIVEL_2'],
  },

  { path: '/minutas', component: Minutas, permissions: ['MINUTA_MINUTAS'] },

  { path: '/definicaoDeComprador', component: DefinicaoDeComprador, permissions: ['CONTRATO_GERAL_VISUALIZAR_MENU'] },
  { path: '/direcionarRevisoes', component: DirecionarRevisoes, permissions: ['CONTRATO_GERAL_VISUALIZAR_MENU'] },
  { path: '/demanda/questionario/:id', component: PreSuprimentosDemandas },
  { path: '/demanda/sumarioExecutivo/:id', component: SumarioExecutivo },
  {
    path: '/demanda/requisitanteCapex',
    component: RequisitanteCapex,
    permissions: ['PRE_SUPRIMENTOS_DEMANDA_MENU_REQUISITANTE_CAPEX_VISUALIZAR'],
  },
  {
    path: '/demanda/validacaoCapex',
    component: ValidacaoCapex,
    permissions: ['PRE_SUPRIMENTOS_DEMANDA_MENU_VALIDACAO_CAPEX_VISUALIZAR'],
  },
  { path: '/demanda/controladoria', component: Controladoria },
  { path: '/bidCycle', component: BidCycle, permissions: ['SAS_BID_CYCLE_VISUALIZAR_MENU'] },
  { path: '/painelFinanceiro', component: PainelFinanceiro, permissions: ['SAS_PAINEL_FINANCEIRO_VISUALIZAR_MENU'] },
  {
    path: '/manuaiseprocedimentos',
    component: ManuaisEProcedimentos,
    permissions: ['SAS_MANUAIS_E_PROCEDIMENTOS_MENU'],
  },
  {
    path: '/painelFinanceiroformFornecedor',
    component: FormFornecedor,
    permissions: ['SAS_PAINEL_FINANCEIRO_VISUALIZAR_MENU'],
  },
  {
    path: '/ordensCompra',
    component: RelatorioOrdemCompra,
    permissions: ['SAS_ORDENS_COMPRA_VISUALIZAR_MENU'],
  },
  {
    path: '/relatorioDashboard',
    component: RelatorioDashboard,
    permissions: ['SAS_DASHBOARD_VISUALIZAR_MENU'],
  },
  {
    path: '/ordemCompra/:id',
    component: OrdemCompra,
  },
  {
    path: '/sasProposta/:id',
    component: Proposta,
  },
  {
    path: '/classificacaoServico',
    component: ClassificacaoServico,
    permissions: ['CLASSIFICACAO_SERVICO_VISUALIZAR_MENU'],
  },
  {
    path: '/relatorioClassificacaoGastos',
    component: RelatorioClassificacaoGastos,
    permissions: ['RELATORIO_CLASSIFICACAO_GASTOS_MENU'],
  },
  {
    path: '/relatorioMonitoramentoSubcontratacoes',
    component: RelatorioMonitoramentoSubcontratacoes,
    permissions: ['RELATORIO_MONITORAMENTO_SUBCONTRATACOES_MENU'],
  },
  {
    path: '/relatorioSubcontratacoes',
    component: RelatorioSubContratacao,
  },
];

const App = () => {
  const item = localStorage.getItem('isAuthenticated');
  const userName = getLoggedUsername();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(item ? true : false);

  const header = {
    logo: Logo,
    title: app.name.toUpperCase(),
    onLogout,
    translationConfig: undefined,
  };

  function onLogout() {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('isMRN');
    localStorage.removeItem('idtoken');
    localStorage.removeItem('expiration');
    storage.setPermissions([]);
    setIsAuthenticated(false);
  }

  useEffect(() => {
    window.history.scrollRestoration = 'manual';
    const jwt = getJwt();
    const exp = getExpirationTime();
    if (jwt === undefined) onLogout();
    else if (exp !== 0 && Date.now() >= exp * 1000) {
      notification.error('Tempo de login expirado.');
      onLogout();
    }
  }, []);

  useEffect(() => {
    (function (
      c: any,
      l: Document,
      a: string,
      r: string,
      i: any,
      t: HTMLScriptElement | undefined,
      y: Element | undefined,
    ) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r) as HTMLScriptElement;
      t.async = true;
      t.src = 'https://www.clarity.ms/tag/ub4cil5bod';
      y = l.getElementsByTagName(r)[0];
      if (y && y.parentNode) {
        y.parentNode.insertBefore(t, y);
      }
    })(window, document, 'clarity', 'script', undefined, undefined, undefined);
  }, []);
  useEffect(() => {
    (function (
      c: any,
      l: Document,
      a: string,
      r: string,
      i: any,
      t: HTMLScriptElement | undefined,
      y: Element | undefined,
    ) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r) as HTMLScriptElement;
      t.async = true;
      t.src = 'https://www.clarity.ms/tag/ub902gxlfg';
      y = l.getElementsByTagName(r)[0];
      if (y && y.parentNode) {
        y.parentNode.insertBefore(t, y);
      }
    })(window, document, 'clarity', 'script', undefined, undefined, undefined);
  }, []);
  const MRNWorkspace = () => {
    // const menuFullCollapsed = useStore(state => state.ui.menuFullCollapsed);
    // const setMenuFullCollapsed = useActions(state => state.ui.setMenuFullCollapsed);

    // const masterAreaCollapsed = useStore(state => state.ui.masterAreaCollapsed);
    // const setMasterAreaCollapsed = useActions(state => state.ui.setMasterAreaCollapsed);

    // const resizeMenuFullCollapsed = () => setTimeout(() => setMenuFullCollapsed(true), 50);
    // const resizeMasterAreaCollapsed = () => setTimeout(() => setMasterAreaCollapsed(true), 50);

    // useEffect(() => {
    //   !menuFullCollapsed && window.removeEventListener('resize', resizeMenuFullCollapsed);
    // }, [menuFullCollapsed]);

    // useEffect(() => {
    //   !masterAreaCollapsed && window.removeEventListener('resize', resizeMasterAreaCollapsed);
    // }, [masterAreaCollapsed]);

    // menuFullCollapsed && window.addEventListener('resize', resizeMenuFullCollapsed);
    // masterAreaCollapsed && window.addEventListener('resize', resizeMasterAreaCollapsed);

    return (
      <RecoilRoot>
        <RecoilGlobal>
          <Workspace
            menu={addMenuTopAreaItem(menu, { label: userName, icon: 'profile-user_male_circle', uri: '/meusDados' })}>
            <Switch>
              {createRoutes(routes)}
              <Route path="/" exact component={NotFound} />
            </Switch>
          </Workspace>
        </RecoilGlobal>
      </RecoilRoot>
    );
  };

  const RecoilGlobal = ({ children }: any) => {
    const setParametrosSas = useSetRecoilState(parametrosSasState);
    const setUsuarioLogado = useSetRecoilState(usuarioLogadoState);

    useLayoutEffect(() => {
      GetSas().then(dadosParametrosSas => {
        if (dadosParametrosSas) {
          setParametrosSas(dadosParametrosSas);
        }
      });

      getUsuarioLogadoInfo().then(data => {
        if (data) {
          setUsuarioLogado(data);
        }
      });
    }, []);

    return children;
  };

  const AppInner = ({ onAuthenticate, isAuthenticated }: any) => {
    const loadPermissions = useActions((state: any) => state.permission.loadPermissions);

    useEffect(() => {
      initMsal(loadPermissions, onAuthenticate);
    }, [loadPermissions]);

    return (
      <Router>
        <Switch>
          
          <Route path="/auth/redirect" exact render={() => <AuthRedirect />} />

          <Route
            path="/ordemCompraPropostaTecnicaDownload/:key"
            exact
            render={() => <OrdemCompraPropostaTecnicaDownload />}
          />

          <Route path="/loginPortal" exact render={() => <LoginPortal onAuthenticate={onAuthenticate} />} />

          <Route path="/logoutPortal" exact render={() => <LogoutPortal onLogout={() => {}} />} />
          <Route path="/recuperarSenha" exact render={() => <RecuperarSenha />} />

          <Route
            path="/login"
            exact
            render={() => <Login isAuthenticated={isAuthenticated} onAuthenticate={onAuthenticate} />}
          />

          <PrivateRoute path="/" component={MRNWorkspace} isAuthenticated={isAuthenticated} redirectTo="/login" />
        </Switch>
      </Router>
    );
  };

  return (
    <AuthProvider instance={msalInstance}>
      <Router>
        <Switch>
          <AppContainer models={models} header={isAuthenticated ? header : {}}>
            <AppInner onAuthenticate={setIsAuthenticated} isAuthenticated={isAuthenticated} />
          </AppContainer>
        </Switch>
      </Router>
    </AuthProvider>
  );
};

export default App;
